import algoliasearch from "algoliasearch";
import { useEffect, useState } from "react";

const APPLICATION_ID = "2JUPZ32549";
const SEARCH_API_KEY = "c26e3cca2cd5931e930f9c3444299b32";

const INDEX_NAME = "hollow_commissions";

const client = algoliasearch(APPLICATION_ID, SEARCH_API_KEY);
const index = client.initIndex(INDEX_NAME);

export function useSearchResults(query) {
  const [results, setResults] = useState([]);

  useEffect(() => {
    let unmounted = false;
    index
      .search(query, { hitsPerPage: 1000 })
      .then(({ hits }) => {
        if (!unmounted) {
          setResults(hits);
        }
      })
      .catch((err) => {
        console.log(err);
      });
    return () => {
      unmounted = true;
    };
  }, [query]);

  return results;
}
